import * as React from 'react';
import { v4 as uuid } from 'uuid';
import { useIORef } from '../../core/hooks';
import { useSetter, useEffect, useGetter } from './slots';
import { SelectProps } from './types';
import { takeCursorData } from './Input';


const Component: React.FunctionComponent<SelectProps> = ({
    name,
    onSelect,
    onClear = () => {},
    children,
}) => {

    const {
        read: isActive,
        write: writeActive,
    } = useIORef(false);

    const id = React.useMemo(() => uuid(), []);


    const dropdownController =  useGetter('dropdown');
    const dropdownTarget =      useGetter('dropdownTarget');
    const target =              useGetter('target');
    const cursorController =    useGetter('cursor');

    const [, runActive] =       useEffect('selectActivate');
    const [, runInactive] =     useEffect('selectInactivate');

    const _on = writeActive(true);
    const _off = writeActive(false);

    const on = React.useCallback(runActive(() => {
        _on();
    }), []);

    const off = React.useCallback(runInactive(() => {
        _off();
    }), []);


    const batch = () => {
        const cursorPosition = cursorController.get();
        const data = dropdownTarget.getMutableData();
        const value = takeCursorData(target.getValue(), cursorPosition, data);

        onSelect(value, name);
        target.change(value);
        dropdownController.close();
        target.inactive();
    };

    useSetter('select', {
        id,
        isActive,
        on,
        off,
        batch,
    });

    useSetter('service', {
        name,
        onSelect,
        onClear,
    });

    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
}

export default Component;
